// ============================================================================
// GERMAN TRANSLATIONS - CHAPTER 4: KREUZIGUNG UND AUFERSTEHUNG
// ============================================================================
// Stufen 40-52 (13 Stufen, 39 Fragen)

export const chapter4Translations = {
  name: "Kreuzigung und Auferstehung",
  description: "Er ist auferstanden!",
  
  spiritualWisdom: {
    principle: "Durch seinen Tod und seine Auferstehung schenkt uns Jesus das ewige Leben",
    scripture: "Ich bin die Auferstehung und das Leben. Wer an mich glaubt, wird leben, auch wenn er stirbt (Johannes 11:25)",
    application: "Das Kreuz und das leere Grab sind das Herz unseres Glaubens und die Quelle unserer Hoffnung"
  },
  
  levels: {
    40: {
      name: "Die Verhaftung",
      challenge: "Judas, verrätst du den Menschensohn mit einem Kuss?",
      easy: {
        question: "Wer verriet Jesus?",
        options: ["Petrus", "Judas", "Thomas", "Matthäus"],
        hint: "Einer der zwölf Jünger",
        funFact: "💔 Judas verkaufte Jesus für 30 Silberstücke - der Preis eines Sklaven!"
      },
      medium: {
        question: "Welches Zeichen benutzte Judas, um Jesus zu identifizieren?",
        options: [
          "Er zeigte mit dem Finger auf ihn",
          "Er rief seinen Namen",
          "Er gab ihm einen Kuss",
          "Er wies die Soldaten auf ihn hin"
        ],
        hint: "Eine Geste der Zuneigung wurde pervertiert",
        funFact: "😢 Der Kuss, Symbol der Liebe, wird zum Werkzeug des Verrats!"
      },
      hard: {
        question: "Wie reagierte Jesus auf Verrat und Verhaftung?",
        options: [
          "Er verteidigte sich gewaltsam",
          "Er floh",
          "Er akzeptierte würdevoll und heilte das Ohr des Dieners",
          "Er verfluchte seine Feinde"
        ],
        hint: "Er zeigte Liebe selbst gegenüber seinen Feinden",
        funFact: "✨ Selbst bei seiner Verhaftung heilte Jesus das abgehauene Ohr von Malchus!"
      }
    },
    
    41: {
      name: "Die Verleugnung des Petrus",
      challenge: "Bevor der Hahn kräht, wirst du mich dreimal verleugnen...",
      easy: {
        question: "Wie oft verleugnete Petrus Jesus?",
        options: ["1 Mal", "2 Mal", "3 Mal", "4 Mal"],
        hint: "Die Zahl, die Jesus vorhergesagt hatte",
        funFact: "🐓 Das Krähen des Hahns erinnerte Petrus an Jesu Prophezeiung!"
      },
      medium: {
        question: "Wo war Petrus, als er Jesus verleugnete?",
        options: [
          "Im Tempel",
          "Bei Pilatus",
          "Im Hof des Hohenpriesters",
          "Auf der Straße"
        ],
        hint: "Er folgte Jesus aus der Ferne",
        funFact: "🔥 Petrus wärmte sich am Feuer mit den Feinden Jesu!"
      },
      hard: {
        question: "Was lehrt uns die Wiederherstellung des Petrus nach seiner Verleugnung?",
        options: [
          "Manche Sünden sind unverzeihlich",
          "Jesu Liebe richtet uns auch nach unseren größten Fehlern wieder auf",
          "Petrus war unwürdig",
          "Man muss seine Fehler verbergen"
        ],
        hint: "Es geht um die Gnade, die wiederherstellt",
        funFact: "💝 Jesus fragt 3 Mal 'Liebst du mich?' um die 3 Verleugnungen wiederherzustellen!"
      }
    },

    42: {
      name: "Jesus vor Pilatus",
      challenge: "Bist du der König der Juden? Du sagst es...",
      easy: {
        question: "Wer war der römische Statthalter, der Jesus verurteilte?",
        options: ["Cäsar", "Pilatus", "Herodes", "Antonius"],
        hint: "Roms Vertreter in Judäa",
        funFact: "⚖️ Pilatus erkennt Jesu Unschuld an, verurteilt ihn aber aus Feigheit!"
      },
      medium: {
        question: "Welchen Brauch schlug Pilatus vor zu nutzen?",
        options: [
          "Einen Gefangenen zum Passahfest freizulassen",
          "Das Urteil zu verschieben",
          "An Cäsar zu appellieren",
          "Jesus zu verbannen"
        ],
        hint: "Eine Passah-Tradition",
        funFact: "🔓 Pilatus hoffte, Jesus durch diesen Passahbrauch freizulassen!"
      },
      hard: {
        question: "Was offenbart Pilatus' Haltung über menschliche Gerechtigkeit?",
        options: [
          "Gerechtigkeit wird immer gesprochen",
          "Volksdruck kann selbst die Gerechtigkeit korrumpieren",
          "Pilatus war böse",
          "Politik geht vor Wahrheit"
        ],
        hint: "Es geht um Schwäche vor der Menge",
        funFact: "💧 Pilatus wäscht seine Hände, bleibt aber für das Unrecht verantwortlich!"
      }
    }
  }
};

export default chapter4Translations;
